/**
 * The resulting parse tree nodes of the parse tree.
 */
function ParseNode(type, value, mode) {
    this.type = type;
    this.value = value;
    this.mode = mode;
}

module.exports = {
    ParseNode: ParseNode,
};




//////////////////
// WEBPACK FOOTER
// ./~/katex/src/parseData.js
// module id = 72
// module chunks = 0